import 'whatwg-fetch';

const fetchSummary = async (newUrl) => {
    const url = new URL(newUrl);
    url.pathname = '/api/v2/summary.json';

    const response = await fetch(url.toString());
    if (!response.ok) {
        throw new Error(response.statusText);
    }
    return response.json();
};

export default fetchSummary;
